import { useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Collapse from '@mui/material/Collapse'
import FilterListIcon from '@mui/icons-material/FilterList'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useDesktop } from 'components/core/SplitPanes'

// The Moments page's title row, over either view. On a desktop the account
// filter sits at its right, and the view lays out its own filters on the row
// under it. On a phone every filter, the account's included, folds behind a
// Filters button under the title (owner, 2026-10-21), and the button counts
// the filters narrowing the list, so a folded one is never forgotten. The
// list under the open fold follows each change as it is made.
const FilterHeader = ({ title, account, filters, active }) => {
  const desktop = useDesktop()
  const [open, setOpen] = useState(false)
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 2,
          mb: desktop ? 3 : 2,
        }}
      >
        {title}
        {desktop ? (
          <>
            <Box sx={{ flex: 1 }} />
            {account}
          </>
        ) : (
          <Button
            size="small"
            variant="outlined"
            aria-expanded={open}
            onClick={() => setOpen((o) => !o)}
            startIcon={<FilterListIcon />}
            endIcon={
              <ExpandMoreIcon
                sx={{
                  transform: open ? 'rotate(180deg)' : 'none',
                  transition: 'transform 150ms',
                }}
              />
            }
            sx={{ textTransform: 'none' }}
          >
            Filters{active ? ` · ${active}` : ''}
          </Button>
        )}
      </Box>
      {!desktop && (
        <Collapse in={open}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: 1.5,
              mb: 2,
            }}
          >
            {account}
            {filters}
          </Box>
        </Collapse>
      )}
    </>
  )
}

export default FilterHeader
